import { useCallback, useEffect } from 'react';

const useUnsavedChangesWarning = (
  hasUnsaved,
  message = 'Все несохраненные изменения будут потеряны. Выйти?'
) => {
  useEffect(() => {
    if (!hasUnsaved) {
      return;
    }

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsaved]);

  const confirmLeave = useCallback(() => {
    if (!hasUnsaved) {
      return true;
    }
    return window.confirm(message);
  }, [hasUnsaved, message]);

  return { confirmLeave };
};

export default useUnsavedChangesWarning;
